import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const VMConstants = {
    VMs_LOADED: 'VMS_LOADED',
    VMs_CLEARED: 'VMS_CLEARED',
    VM_CREATED: 'VM_CREATED',
    VM_UPDATED: 'VM_UPDATED',
    VM_DELETED: 'VM_DELETED'
};

export const VMsFulfilledConstants = getActionTypesResult(VMConstants, '_FULFILLED');
export const VMsPendingConstants = getActionTypesResult(VMConstants, '_PENDING');
export const VMsRejectedConstants = getActionTypesResult(VMConstants, '_REJECTED');

export const fetchVMs = createAsyncAction(VMConstants.VMs_LOADED, query =>
    api.get('vm', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
);

export const clearVMs = () => ({
    type: VMConstants.VMs_CLEARED
});

export const saveVM = createAsyncAction(VMConstants.VM_CREATED, device =>
    api.post('vm/virtualMachine', device).then(res => res.data)
);

export const updateVM = createAsyncAction(VMConstants.VM_UPDATED, (deviceId, device) =>
    api.put('vm', device).then(res => res.data)
);

export const deleteVM = createAsyncAction(VMConstants.VM_DELETED, virtualMachineId =>
    api.delete(`vm/${virtualMachineId}`).then(res => res.data)
);
